import { createContext } from 'react'
import type { SectionType } from '../types'

export interface SelectedSection {
  id: string
  title: string
  type: SectionType
}

/**
 * Represents a selected file with minimal selection representation.
 * - null sections: remove file from context
 * - Empty sections array: entire file is selected
 * - Non-empty sections array: only specified sections selected (file is indeterminate)
 */
export interface SelectedFile {
  id: string
  fileName: string
  extension: string
  sections: SelectedSection[] | null
}

export interface SelectedFilesContextType {
  selectedFiles: SelectedFile[]
  clearAll: () => void
  updateFileSelection: (file: SelectedFile) => void
  getFileSelection: (fileId: string) => SelectedFile | undefined
  replaceSelections: (files: SelectedFile[]) => void
}

export const SelectedFilesContext = createContext<SelectedFilesContextType | undefined>(undefined)
